import { Skeleton } from '@mui/material';

export const MetadataFieldMappingMatchCountSkeleton = () => {
  return (
    <Skeleton
      variant="rounded"
      width={10}
      height={10}
      sx={{
        display: 'inline-block',
        verticalAlign: 'middle',
        bgcolor: 'text.disabled',
      }}
    />
  );
};
